/**
 * Header Component for FlowRide Frontend
 * Displays the FlowRide logo with animated positioning and backdrop blur effect.
 * Adapts its size and position based on the current page context.
 */

import { useEffect, useRef } from "react";
import darkLogo from "../image/brand/DarkLogo.svg";

interface ContainerProps {

    /** Whether the header is displayed on the home page */
    "isHome": boolean;
}

const Header: React.FC<ContainerProps> = ( { isHome } ) => {
    /** Reference to the main header div for animation control */
    const mainDiv = useRef<HTMLDivElement>( null );

    /**
     * Effect hook for header animation
     * Moves the header up after 2 seconds to create a smooth entrance effect
     */
    useEffect( () => {
        setTimeout( () => {
            if ( mainDiv.current !== null ) {
                mainDiv.current.style.marginTop = "-30px";
            }
        }, 2000 );
    }, [] );

    return (
        <div
            className={`absolute top-0 h-${ isHome ? "7" : "16" } z-30 justify-center flex w-full transition-all ease-linear delay-500`}
            ref={mainDiv}
        >
            <div className="bg-white bg-opacity-50 backdrop-blur-md border border-white border-opacity-20 px-3 justify-center flex rounded-b-xl">
                <img
                    src={darkLogo}
                    width={isHome ? 80 : 140}
                />
            </div>
        </div>
    );
};

export default Header;
